import { SVGProps } from 'react';

import palette from '../../../theme/palette';
import { styleConfigs } from '../../resources/styleConfigs';

const PencilRulerIcon = ({
  width = styleConfigs.dimensions.width24,
  height = styleConfigs.dimensions.height24,
  stroke = palette.light.icons.mistBlue,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.25 23.2502V23.2502C3.59315 23.2502 2.25 21.907 2.25 20.2502V7.4582C2.24967 6.99259 2.35823 6.53337 2.567 6.1172L4.579 2.0922C4.70597 1.83791 4.96578 1.67725 5.25 1.67725C5.53422 1.67725 5.79403 1.83791 5.921 2.0922L7.933 6.1172C8.14177 6.53337 8.25033 6.99259 8.25 7.4582V20.2502C8.25 21.907 6.90685 23.2502 5.25 23.2502Z"
      stroke={stroke}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2.33496 6.75H8.16496" stroke={stroke} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2.25 19.5H8.25" stroke={stroke} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.75 2.25C12.75 1.42157 13.4216 0.75 14.25 0.75H20.25C21.0784 0.75 21.75 1.42157 21.75 2.25V21.75C21.75 22.5784 21.0784 23.25 20.25 23.25H14.25C13.4216 23.25 12.75 22.5784 12.75 21.75V2.25Z"
      stroke={stroke}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12.75 5.25H15.75" stroke={stroke} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.75 9.75H15.75" stroke={stroke} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.75 14.25H15.75" stroke={stroke} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.75 18.75H15.75" stroke={stroke} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default PencilRulerIcon;
